import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'offers'
const verb = HttpMethod.DELETE

export default class OspreyOffersDelete extends BaseAction {
    constructor(dataKey, onError) {
        const id = '44444ed8-6046-11e9-8e2d-2f3fd94c8e5d'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = onError
    }

    deleteOffers(params) {
        const { offerIds } = params

        if (Array.isArray(offerIds.value)) {
            this.path = `/${resource}`
            this.params = params
        }
        else {
            this.params = undefined
            this.path = `/${resource}/${offerIds.value}`
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-delete.js